/**
 * Code from Josh W Comeau
 * https://joshwcomeau.com/react/boop/
 */
import React from "react"
import { useSpring, SpringConfig } from "@react-spring/web"
export type BoopProps = {
  x?: number
  y?: number
  rotation?: number
  scale?: number
  timing?: number
  springConfig?: SpringConfig
  disabled?: boolean
}
export default function useBoop({
  x = 0,
  y = 0,
  rotation = 0,
  scale = 1,
  timing = 150,
  springConfig = {
    tension: 300,
    friction: 10,
  },
  disabled = false,
}: BoopProps): [{}, () => void] {
  const [isBooped, setIsBooped] = React.useState(false)
  const style = useSpring({
    transform: isBooped
      ? `translate(${x}px, ${y}px)
          rotate(${rotation}deg)
          scale(${scale})`
      : `translate(0px, 0px)
          rotate(0deg)
          scale(1)`,
    config: springConfig,
    cancel: disabled,
  })
  React.useEffect(() => {
    if (!isBooped) {
      return
    }
    const timeoutId = window.setTimeout(() => {
      setIsBooped(false)
    }, timing)
    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [isBooped])
  const trigger = React.useCallback(() => {
    setIsBooped(true)
  }, [])
  return [style, trigger]
}
